import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import {connect} from 'react-redux';
import BtnWhite from '../../../Shared/Buttons/BtnWhite';
import ChooseCellularServices from '../ChooseCellularServices/ChooseCellularServices';
import {showPopup, reportAnalytics} from './NewCellNumberSuccessSlice';

const newCellNumberSuccess = (props) => {
  const additionalNumberHandler = () => {
    return props.onChooseAdditionalNumber();
  };

  const contentServicesHandler = (props) => {
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'click_14' : 'click_35',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
    props.reportAnalytics({
      eventCategory: 'cellular_newsale_process',
      eventAction: props.flowType == 'existsCustomer' ? 'visibility_7' : 'visibility_18',
      eventLabel: props.productsInfo.selectedProducts[0]?.name,
    });
    props.showPopup({show: true});
  };

  return (
    <Container className='newCellNumberSuccess'>
      <Row>
        <Col className='cellcom-number-container'>
          <Row>
            <Col>
              <p className='your-number'>רק מוודאים שזה המספר שאיתו תצטרפו:</p>
            </Col>
          </Row>
          <Row className='cellcom-phone'>
            <Col xs='1'>
              <Image src={require('./images/mobile-black.svg')} alt='טלפון תמונה' />
            </Col>
            <Col xs='6' md='4' className='cellcom-phone-number'>
              <p> {props.selectedPhone} </p>
            </Col>
            <Col xs='4' className='cellcom-phone-edit' onClick={props.onBackToChooseNumberPage}>
              <p>עדכון מספר</p>
            </Col>
          </Row>

          {props.selectedProduct?.selectedVasList && props.selectedProduct.selectedVasList.length > 0 && (
            <Row>
              <Col>
                <div className='selected-vas-list-wrapper'>
                  {props.selectedProduct.selectedVasList?.map(function (vas, i) {
                    return <div className='vas-item'> {vas.title} </div>;
                  })}
                </div>
              </Col>
            </Row>
          )}
          {props.selectedProduct?.isPrettyNum && (
            <div className='selected-vas-list-wrapper'>
              <div className='vas-item'>{props.selectedProduct?.prettyNumberName}</div>
            </div>
          )}
          <Row>
            <Col sm='12' className='additional' onClick={() => contentServicesHandler(props)}>
              <a>להגדרת שירותי תוכן וחיוג בתשלום</a>
              <Image src={require('./images/arrow.svg')} className='additional-arrow' alt='חץ' />
            </Col>
          </Row>
        </Col>
      </Row>

      {props.isDisplayAdditionalNumber && (
        <Row>
          <Col className='btn-holder'>
            <BtnWhite text={'להזמנת מספר נוסף'} onclick={() => additionalNumberHandler()} />
          </Col>
        </Row>
      )}

      <ChooseCellularServices
        showPopUp={props.isDisplayPopup}
        onClose={() => props.showPopup({show: false})}
        bottomLink='שילחו שוב'
        linkText={`בחירת שירותים עבור מספר ${props.selectedPhone}`}
        subTitle='שירותי חיוג ותוכן'
      />
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    isDisplayPopup: state.newCellNumberSuccess.isDisplayPopup,
    productsInfo: state.saleBlock.productsInfo,
    flowType: state.saleBlock.flowType,
  };
};

const mapDispatchToProps = {showPopup, reportAnalytics};

export default connect(mapStateToProps, mapDispatchToProps)(newCellNumberSuccess);
